import Contentstack from "contentstack";
// preval requires relative imports
import * as env from '../env';

export const Stack = Contentstack.Stack({
  api_key: `${env.CONTENT_STACK_API_KEY}`,
  delivery_token: `${env.CONTENT_STACK_DELIVERY_TOKEN}`,
  environment: `${env.CONTENT_STACK_ENV}`
});

const LANG = { es: "es-mx", en: "en-us" };

function generateCSQuery(locale = "es") {
  return Stack.ContentType(`${env.CONTENT_STACK_ARTICLES}`)
    .Query()
    .addParam("locale", LANG[locale]);
}

export function getArticleCount({category = undefined, lang}) {
  let query = generateCSQuery(lang);
  if (category) query = query.containedIn("article_category", [category]);
  return query
    .notEqualTo("archive", true)
    .count()
    .toJSON()
    .find();
}

export function searchByTag(tag, success, error) {
  generateCSQuery()
    .containedIn("tags", [tag])
    .toJSON()
    .find()
    .then(success, error);
}

export function searchAll(input, success, error) {
  const category = generateCSQuery()
    .containedIn("category", [input])
    .getQuery();

  const tags = generateCSQuery()
    .containedIn("tags", [input])
    .getQuery();

  generateCSQuery()
    .or(category, tags)
    .toJSON()
    .find()
    .then(success, error);
}

export function getArticles(category, lang, haveArticles = [], skip = 0) {
  let query = generateCSQuery(lang);
  if (category) query = query.containedIn("article_category", [category]);

  return query
    .notContainedIn("uid", haveArticles)
    .skip(skip)
    .limit(parseInt(`${env.CONTENT_STACK_PAGINATE_AFTER}`, 10))
    .notEqualTo("archive", true)
    .toJSON()
    .find();
}

export async function fetchArticle(url, locale) {
  const res = await generateCSQuery(locale)
    .containedIn("url", [url])
    .toJSON()
    .find();
  return res[0][0];
}

export async function fetchArticleWithFallback(url, locale) {
  const result = await fetchArticle(url, locale);
  if (!result && locale === 'en') {
    return fetchArticle(url, 'es');
  }
  return result;
}

function generateCSLegalQuery(locale = "es") {
  return Stack.ContentType(`${env.CONTENT_STACK_LEGAL}`)
    .Query()
    .descending("created_at")
    .addParam("locale", LANG[locale]);
}

export async function fetchLegalDisclosure(url, locale) {
  const res = await generateCSLegalQuery(locale)
    .containedIn("url", [url])
    .toJSON()
    .find();
  return res[0][0];
}

export async function getLegalDisclosures(lang) {
  const res = await generateCSLegalQuery(lang)
    .toJSON()
    .find();
  return res[0];
}
